import React from 'react';
import RiskRow from './RiskRow';
import EmptyState from '../shared/EmptyState';
import Pagination from '../shared/Pagination';

function RisksList({ risks, meta, page, onPageChange, onUpdated, onRiskClick, showToast }) {
  if (!risks.length) {
    return <EmptyState icon="✅" title="Sin riesgos" description="No hay riesgos con los filtros actuales." />;
  }
  return (
    <div>
      <div className="list-container">
        {risks.map(r => (
          <RiskRow
            key={r.id}
            risk={r}
            onUpdated={onUpdated}
            onRiskClick={onRiskClick}
            showToast={showToast}
          />
        ))}
      </div>
      <Pagination page={page} totalPages={meta?.totalPages || 1} onPageChange={onPageChange} />
    </div>
  );
}

export default RisksList;
